import "babel-polyfill";
import "cross-fetch/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import Vuelidate from "vuelidate";
// import VueDraggable from 'vue-draggable'
import Storage from "vue-ls";
import { routerBack } from "@/utils/routerBack";
import store from "./store";

let options = {
  namespace: "vuejs__", // key prefix
  name: "ls", // name variable Vue.[ls] or this.[$ls],
  storage: "local", // storage name session, local, memory
};

Vue.use(Storage, options);
Vue.use(Vuelidate);
// Vue.use(VueDraggable)

// ================
// Vue-stash aka simple vuex alternative
// ----------------
import VueStash from "vue-stash";
Vue.use(VueStash);

import VueToast from "vue-toast-notification";
// Import any of available themes
import "vue-toast-notification/dist/theme-default.css";
//import 'vue-toast-notification/dist/theme-sugar.css';

import FlagIcon from "vue-flag-icon";
Vue.use(FlagIcon);
Vue.use(VueToast, {
  position: "top-right",
  duration: 4000,
});
// Component error message
import ErrorMessage from "@/components/ErrorMessage/ErrorMessage";
import Upload from "@/components/Upload/Upload";
Vue.component("base-error", ErrorMessage);
Vue.component("base-upload", Upload);

Vue.config.productionTip = false;

// ================
// Lodash
// ----------------
import VueLodash from "vue-lodash";
import lodash from "lodash";

// name is optional
Vue.use(VueLodash, { name: "custom", lodash: lodash });

// ================
// Vue-moment
// ----------------
import VueMoment from "vue-moment";
import moment from "moment-timezone";
Vue.use(VueMoment, {
  moment,
});

Vue.prototype.$routerBack = routerBack;

const vm = new Vue({
  router,
  vuetify,
  i18n,
  data: { store },
  render: (h) => h(App),
}).$mount("#app");

export default vm;
